import { Clock, DollarSign, Sparkles, Users } from "lucide-react";

export const BenefitsSection = () => {
  const benefits = [
    {
      icon: <Clock className="h-12 w-12 text-blue-600" />,
      title: "Save Time",
      description: "Reduce manual work and focus on strategic tasks",
    },
    {
      icon: <DollarSign className="h-12 w-12 text-blue-600" />,
      title: "Reduce Costs",
      description: "Lower operational costs through efficient automation",
    },
    {
      icon: <Sparkles className="h-12 w-12 text-blue-600" />,
      title: "Improve Accuracy",
      description: "Eliminate human error in repetitive tasks",
    },
    {
      icon: <Users className="h-12 w-12 text-blue-600" />,
      title: "Scale Operations",
      description: "Handle growing workloads without adding headcount",
    },
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-bold text-center mb-12">
          Benefits of Automation
        </h2>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="text-center p-6 rounded-lg hover:bg-blue-50 transition-colors"
            >
              <div className="mb-4 flex justify-center">{benefit.icon}</div>
              <h3 className="text-xl font-semibold mb-2">{benefit.title}</h3>
              <p className="text-gray-600">{benefit.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};